import { Outlet } from "react-router";
import Header from "../../../component/layout/header";
import useNav from "../../../script/tabingNavArray";

const SaleTeamLayout = () => {
   const navList = useNav();
  let { saleTeamBottomNav, saleTopNav } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={saleTeamBottomNav} topTabs={saleTopNav} />
      <Outlet />
    </div>
  )
}

export default SaleTeamLayout;